export default "__VITE_ASSET__m99yccgE__"